import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useViewportMode } from '../../contexts/ViewportModeContext.js';
// The claim reads the slice registrations, loaded here so the hint works
// whichever canvas, if any, imported them first.
import '../../nodes/index.js';
import { isClaimedByCanvasItemEditor } from '../../nodeWorkspaceVisibility.js';
import { useLiveSceneNodes, useSeatedRoots } from '../../useLiveSceneTree.js';
import { keepsChildrenInViewport } from '../../../nodes/viewport/subviewport/viewportBoundary.js';
import { TscnCanvas } from '../../TscnCanvas.js';
import { Canvas2DStage } from '../Canvas2DStage/Canvas2DStage.js';
import { ViewportControlsHelp } from '../ViewportControlsHelp/ViewportControlsHelp.js';
import styles from './TscnPreviewShell.module.css';
// Module-level, so the memo of `useLiveSceneNodes` does not recompute each render.
const IS_2D_CONTENT = (node) => isClaimedByCanvasItemEditor(node.type);
export function ViewportArea({ sceneGraph, scenePath, }) {
    const { mode, setMode } = useViewportMode();
    const rootScene = sceneGraph?.scenes.get(sceneGraph.rootScene);
    const rootNodes = useSeatedRoots() ?? rootScene?.nodes ?? [];
    // The live tree finds 2D content inside a sub-scene too. The walk stops at a
    // sub-viewport, whose Controls show only through a viewport surface. A
    // SubViewportContainer still counts, since it draws in 2D (ADR-0033).
    const has2DContent = useLiveSceneNodes(IS_2D_CONTENT, keepsChildrenInViewport).length > 0;
    if (mode === '2D') {
        return (_jsxs(_Fragment, { children: [_jsx(Canvas2DStage, { nodes: rootNodes, internalResources: rootScene?.internalResources ?? [], externalResources: rootScene?.externalResources ?? [], editableInstances: rootScene?.editableInstances, scenePath: scenePath }), _jsx(ViewportControlsHelp, { mode: "2D" })] }));
    }
    // CanvasItem content renders only in the 2D workspace, so the 3D one shows a hint.
    return (_jsxs(_Fragment, { children: [_jsx(TscnCanvas, {}), _jsx(ViewportControlsHelp, { mode: "3D" }), has2DContent && (_jsx("button", { type: "button", className: styles.viewportHint, onClick: () => setMode('2D'), title: "This scene contains 2D content \u2014 switch to the 2D view", children: "Has 2D\u00A0content \u2014 switch to 2D" }))] }));
}
//# sourceMappingURL=ViewportArea.js.map